import { workPackagesByCustomerQuery } from "@common/api/work-packages"
import { createFileRoute, useParams } from "@tanstack/react-router"
import { SubHeader } from "@/components/page/section"
import { CustomerWoTable } from "@/routes/_layout/customer_/$customerId/-components/customer-wo-table"

export const Route = createFileRoute(
  "/_layout/customer_/$customerId/wo-history",
)({
  staticData: { breadcrumb: "W/O history" },
  loader: ({ context: { queryClient }, params: { customerId } }) =>
    queryClient.ensureQueryData(
      workPackagesByCustomerQuery({ customer_id: customerId }),
    ),
  component: CustomerWoHistory,
})

function CustomerWoHistory() {
  const { customerId } = useParams({
    from: "/_layout/customer_/$customerId/wo-history",
  })

  return (
    <div className="min-w-0 flex-1 overflow-y-auto bg-background pb-6">
      <SubHeader title="W/O History" />
      <CustomerWoTable customerId={customerId} />
    </div>
  )
}
